// extracted by mini-css-extract-plugin
export default {"wrapper":"EditCompany_wrapper__T7Xhr"};